import { Clock } from "components/icons/generated";
import Badge from "ds/components/Badge";
import { BadgeVariant } from "ds/components/Badge/types";
import Box from "ds/components/Box";
import Tile from "ds/components/Tile";
import TileTitle from "ds/components/Tile/Title";
import Tooltip from "ds/components/Tooltip";
import { IconComponent } from "types/Icon";

export type ProviderTileProps = {
  name: string;
  icon: IconComponent;
  comingSoon?: boolean;
  selected?: boolean;
};

const ProviderTile = ({ name, icon, comingSoon = false, selected }: ProviderTileProps) => (
  <Tile
    title={
      <Box direction="row" align="center" gap="small">
        <TileTitle>{name}</TileTitle>
        {comingSoon && (
          <Tooltip
            on={(props) => (
              <span {...props}>
                <Badge
                  type="strong"
                  variant={BadgeVariant.blue}
                  startIcon={Clock}
                  text="Coming soon"
                  iconOnly
                />
              </span>
            )}
          >
            Coming soon
          </Tooltip>
        )}
      </Box>
    }
    icon={icon}
    selected={selected}
    disabled={comingSoon}
    indicator="radio"
  />
);

export default ProviderTile;
